import { loadView } from '@/helper/utils'
import { mainLayout } from '@/components/layouts/Main'

export default {
  path: '/page',
  component: mainLayout(loadView('page/Page')),
  children: [
    {
      path: 'fixed/:code',
      name: 'PageFixed',
      component: loadView('page/fixed/PageFixed')
    },
    {
      path: 'view/:code',
      name: 'PageView',
      component: loadView('page/view/PageView')
    },
    {
      path: 'preview/:code',
      name: 'PagePreview',
      component: loadView('page/preview/PagePreview')
    }
  ]
}
